import { render, staticRenderFns } from "./choose-map.vue?vue&type=template&id=15f789ee&scoped=true&"
import script from "./choose-map.vue?vue&type=script&lang=js&"
export * from "./choose-map.vue?vue&type=script&lang=js&"
import style0 from "./choose-map.vue?vue&type=style&index=0&id=15f789ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f789ee",
  null
  
)

export default component.exports